import { Severity } from '@sentry/types'
import { has, isPlainObject, split, includes } from 'lodash'
import jsCookie from 'js-cookie'

export const reportUrl = (response, url, postBody, isError = false) => {
  const res = response
  let hasErrCode = false
  if (res) {
    if (has(res, 'code')) {
      hasErrCode = res.code != 1 && res.code != 1001
    }
    if (url && includes(url, 'cms.cekid.com') && has(res, 'code')) {
      hasErrCode = res.code != 0
    }
    if (has(res, 'errno')) {
      hasErrCode = res.errno != 0
    }
  }
  const errMsg = isPlainObject(res)
    ? res.message || res.msg || res.reason || res.errmsg
    : response
  if (hasErrCode || isError) {
    import('@sentry/browser').then(Sentry => {
      Sentry.withScope(scope => {
        scope.setLevel(isError ? Severity.Error : Severity.Warning)
        if (url) {
          scope.setTag('errorUrl', url)
        }
        if (postBody) {
          scope.setExtra('postBody', decodeURIComponent(postBody))
        }
        const uid = jsCookie.get('userCode')
        if (uid) {
          scope.setUser({ id: uid })
        }
        if (errMsg) {
          Sentry.captureMessage(errMsg)
        }
      })
    })
  }
}
